(() => {
  const initialize = (root) => {
    if (root.ccFbtRefresh && root.ccFbtAddSelected) return root.ccFbtRefresh;

    const cards = Array.from(root.querySelectorAll('[data-cc-fbt-card]'));
    const addButton = root.querySelector('[data-cc-fbt-add]');
    const status = root.querySelector('[data-cc-fbt-status]');
    const offerTitle = root.querySelector('[data-cc-fbt-offer-title]');
    const offerCopy = root.querySelector('[data-cc-fbt-offer-copy]');
    const totalLabel = root.querySelector('[data-cc-fbt-total-label]');
    const totalOutput = root.querySelector('[data-cc-fbt-total]');
    const variantsNode = root.querySelector('[data-cc-fbt-main-variants]');
    if (!addButton || !variantsNode) return;
    root.dataset.ccFbtAssetInitialized = 'true';

    const mainVariants = JSON.parse(variantsNode.textContent);
    const mainHandle = root.dataset.ccFbtMainHandle || '';
    const currency = window.Shopify?.currency?.active || 'USD';

    const normalize = (value) => String(value || '').trim().toLowerCase();
    const formatMoney = (cents) => new Intl.NumberFormat(
      document.documentElement.lang || 'en-US',
      { style: 'currency', currency }
    ).format(Number(cents || 0) / 100);

    const getMainForm = () => {
      const forms = Array.from(document.querySelectorAll('form[action*="/cart/add"]'));
      return forms.find((form) => form.querySelector('input[name="id"]')) || null;
    };

    const getMainVariant = () => {
      const id = getMainForm()?.querySelector('input[name="id"]')?.value;
      return mainVariants.find((variant) => String(variant.id) === String(id)) || mainVariants[0];
    };

    const getMainQuantity = () => {
      const quantity = Number(getMainForm()?.querySelector('input[name="quantity"]')?.value || 1);
      return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
    };

    const selectedOption = (card) => {
      const field = card.querySelector('[data-cc-fbt-variant]');
      if (!field) return null;
      return field.tagName === 'SELECT' ? field.options[field.selectedIndex] : field;
    };

    const getCardQuantity = (card) => {
      const input = card.querySelector('[data-cc-fbt-quantity-input]');
      const quantity = Math.min(4, Math.max(1, Number(input?.value || 1)));
      if (input) input.value = quantity;
      return quantity;
    };

    const updateCard = (card) => {
      const option = selectedOption(card);
      const image = card.querySelector('[data-cc-fbt-image]');
      const price = card.querySelector('[data-cc-fbt-price]');
      const selected = card.querySelector('[data-cc-fbt-checkbox]').checked;

      if (option?.dataset.image && image) image.src = option.dataset.image;
      if (option?.dataset.alt && image) image.alt = option.dataset.alt;
      if (price) price.textContent = formatMoney(option?.dataset.price);

      card.classList.toggle('cc-fbt__card--unchecked', !selected);
      card.querySelectorAll('[data-cc-fbt-quantity] button, [data-cc-fbt-quantity] input').forEach(
        (control) => {
          control.disabled = !selected;
        }
      );
    };

    const matchAddonColors = () => {
      const mainColor = normalize(getMainVariant()?.color);
      if (!mainColor) return;

      cards.forEach((card) => {
        const select = card.querySelector('select[data-cc-fbt-variant]');
        if (!select) return;
        const match = Array.from(select.options).find(
          (option) => normalize(option.dataset.color) === mainColor
        );
        if (match) select.value = match.value;
        updateCard(card);
      });
    };

    const refresh = () => {
      const mainVariant = getMainVariant();
      const mainQuantity = getMainQuantity();
      let units = mainQuantity;
      let subtotal = Number(mainVariant?.price || 0) * mainQuantity;
      let selectedAddons = 0;

      cards.forEach((card) => {
        updateCard(card);
        if (!card.querySelector('[data-cc-fbt-checkbox]').checked) return;
        const option = selectedOption(card);
        const quantity = getCardQuantity(card);
        selectedAddons += 1;
        units += quantity;
        subtotal += Number(option?.dataset.price || 0) * quantity;
      });

      const qualifiesForShipping = subtotal >= 7000;

      totalLabel.textContent = 'Bundle subtotal';
      totalOutput.textContent = formatMoney(subtotal);

      if (qualifiesForShipping) {
        offerTitle.textContent = 'Free U.S. shipping unlocked';
        offerCopy.textContent = mainHandle === 'pop-up-beach-trash-bin'
          ? 'Add complementary essentials to your setup.'
          : 'Your coordinated beach-day setup ships free.';
      } else {
        offerTitle.textContent = `${formatMoney(7000 - subtotal)} away from free shipping`;
        offerCopy.textContent = 'Choose any recommendation to complete your setup.';
      }

      addButton.disabled = selectedAddons === 0;
      addButton.textContent = selectedAddons === 0
        ? 'Select an add-on'
        : `Add ${units} ${units === 1 ? 'item' : 'items'} to cart`;
    };

    document.addEventListener('change', (event) => {
      if (!event.target.closest('form[action*="/cart/add"]')) return;
      window.setTimeout(() => {
        matchAddonColors();
        refresh();
      }, 0);
    });

    document.addEventListener('variant:change', () => {
      window.setTimeout(() => {
        matchAddonColors();
        refresh();
      }, 0);
    });

    const addSelected = async () => {
      const mainVariant = getMainVariant();
      const selectedCards = cards.filter(
        (card) => card.querySelector('[data-cc-fbt-checkbox]').checked
      );
      if (!mainVariant || selectedCards.length === 0) return;

      const items = [
        { id: Number(mainVariant.id), quantity: getMainQuantity() },
        ...selectedCards.map((card) => ({
          id: Number(selectedOption(card).value),
          quantity: getCardQuantity(card)
        }))
      ];

      addButton.disabled = true;
      addButton.classList.add('loading');
      addButton.textContent = 'Adding your set…';
      status.textContent = '';

      try {
        const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ items })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Unable to add this set.');

        status.textContent = 'Your selected items were added to cart.';
        window.location.href = window.routes?.cart_url || '/cart';
      } catch (error) {
        status.textContent = error.message || 'Something went wrong. Please try again.';
        addButton.classList.remove('loading');
        refresh();
      }
    };

    matchAddonColors();
    refresh();
    root.ccFbtRefresh = refresh;
    root.ccFbtAddSelected = addSelected;
    return refresh;
  };

  const initializeAll = () => {
    document.querySelectorAll('[data-cc-fbt]').forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-cc-fbt-quantity-change]');
    const addButton = event.target.closest('[data-cc-fbt-add]');
    const root = (button || addButton)?.closest('[data-cc-fbt]');
    if (!root) return;

    const refresh = initialize(root);
    if (button) {
      const card = button.closest('[data-cc-fbt-card]');
      const input = card?.querySelector('[data-cc-fbt-quantity-input]');
      if (!input || !refresh) return;
      const change = Number(button.dataset.ccFbtQuantityChange || 0);
      input.value = Math.min(4, Math.max(1, Number(input.value || 1) + change));
      refresh();
      return;
    }

    if (addButton) root.ccFbtAddSelected?.();
  }, true);

  document.addEventListener('input', (event) => {
    if (!event.target.matches('[data-cc-fbt-quantity-input]')) return;
    const root = event.target.closest('[data-cc-fbt]');
    if (!root) return;
    initialize(root)?.();
  }, true);

  document.addEventListener('change', (event) => {
    if (!event.target.matches(
      '[data-cc-fbt-checkbox], [data-cc-fbt-variant], [data-cc-fbt-quantity-input]'
    )) return;
    const root = event.target.closest('[data-cc-fbt]');
    if (!root) return;
    initialize(root)?.();
  }, true);

  document.addEventListener('shopify:section:load', initializeAll);
})();
